module.exports = __webpack_public_path__ + "static/FondoWeb1-246b39c03ae3ce17bc42c112eab5b0a3.png";